var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.notifyBar.show)?_c('div',{staticClass:"notify"},[_c('span',[_vm._v(" ["+_vm._s(_vm.notify.level)+"]:"+_vm._s(_vm.notify.msg))]),_c('div',{staticClass:"btn-close",on:{"click":_vm.clearNotify}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }